import { Card, Col, Descriptions, Empty, Modal, Row, Space } from 'antd';
import { formatCurrency } from 'utils/number';

const OrderSnapshotModalMobile = ({ open, title, onClose, viewModel }) => {
  const {
    snapshot,
    customerName,
    customerPhone,
    paymentTitle,
    shippingTitle,
    getLineItemName,
  } = viewModel;

  return (
    <Modal title={title} open={open} onCancel={onClose} footer={null} width='100%' style={{ top: 16 }}>
      {!snapshot ? (
        <Empty description='Không có dữ liệu snapshot' />
      ) : (
        <Space direction='vertical' size={12} style={{ width: '100%' }}>
          <Card size='small'>
            <Descriptions column={1} size='small'>
              <Descriptions.Item label='Mã đơn hàng'>{snapshot?.id || '-'}</Descriptions.Item>
              <Descriptions.Item label='Khách hàng'>{customerName}</Descriptions.Item>
              <Descriptions.Item label='SDT'>{customerPhone}</Descriptions.Item>
              <Descriptions.Item label='Thanh toán'>{paymentTitle}</Descriptions.Item>
              <Descriptions.Item label='Vận chuyển'>{shippingTitle}</Descriptions.Item>
              <Descriptions.Item label='Địa chỉ'>{snapshot?.shipping_address?.address || '-'}</Descriptions.Item>
              <Descriptions.Item label='Ghi chú'>{snapshot?.internal?.note || '-'}</Descriptions.Item>
            </Descriptions>
          </Card>

          <Card size='small'>
            <table className='tbl_order' style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>Sản phẩm</th>
                  <th>Số lượng</th>
                  <th>Đơn giá</th>
                  <th>Thành tiền</th>
                </tr>
              </thead>
              <tbody className='ant-table-tbody'>
                {(snapshot?.line_items || []).map((line, index) => {
                  const quantity = Number(line?.quantity || 0);
                  const price = Number(line?.price || 0);
                  const amount = Number(line?.amount || (quantity * price));
                  return (
                    <tr key={`${line?.product_id || 'line'}-${index}`}>
                      <td>{getLineItemName(line)}</td>
                      <td>{quantity}</td>
                      <td style={{ textAlign: 'right' }}>{formatCurrency(price)}</td>
                      <td style={{ textAlign: 'right' }}>{formatCurrency(amount)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Card>

          <Card size='small'>
            <Row gutter={[8, 8]}>
              <Col span={12}>Tiền hàng</Col>
              <Col span={12} style={{ textAlign: 'right' }}>{formatCurrency(snapshot?.sub_amount || 0)}</Col>

              <Col span={12}>Giảm giá</Col>
              <Col span={12} style={{ textAlign: 'right' }}>{formatCurrency(snapshot?.discount_amount || 0)}</Col>

              <Col span={12}>Mã khuyến mãi</Col>
              <Col span={12} style={{ textAlign: 'right' }}>{formatCurrency(snapshot?.voucher_amount || 0)}</Col>

              <Col span={12}>Xu</Col>
              <Col span={12} style={{ textAlign: 'right' }}>{formatCurrency(snapshot?.point_discount || 0)}</Col>

              <Col span={12}>Phí ship</Col>
              <Col span={12} style={{ textAlign: 'right' }}>{formatCurrency(snapshot?.shipping_amount || 0)}</Col>

              <Col span={12}><strong>Tổng tiền</strong></Col>
              <Col span={12} style={{ textAlign: 'right' }}><strong>{formatCurrency(snapshot?.total_amount || 0)}</strong></Col>
            </Row>
          </Card>
        </Space>
      )}
    </Modal>
  );
};

export default OrderSnapshotModalMobile;